var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoland = function SvgGoland(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "goland_svg__a",
    x1: 63.635,
    x2: 39.318,
    y1: 54.045,
    y2: 1.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#00D886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#007DFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goland_svg__b",
    x1: 59.379,
    x2: 0.674,
    y1: 4.381,
    y2: 63.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#007DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D249FC"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00D886",
    d: "m48.052 58.18 11.876-.002A4.07 4.07 0 0 0 64 54.106V42.599c0-1.189-.52-2.319-1.422-3.092L24.416 6.797a4.08 4.08 0 0 0-2.65-.98H9.89a4.073 4.073 0 0 0-4.073 4.072v11.509c0 1.188.52 2.318 1.422 3.092L45.4 57.2c.738.632 1.679.98 2.652.98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#goland_svg__a)",
    d: "M49.48 58.182h10.447A4.073 4.073 0 0 0 64 54.109V41.016q0-.289-.04-.576L58.68 3.497A4.07 4.07 0 0 0 54.65 0H38.977a4.073 4.073 0 0 0-4.073 4.074l.005 18.538c0 .438.07.872.209 1.287l10.5 31.498a4.07 4.07 0 0 0 3.863 2.785"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#goland_svg__b)",
    d: "M4.073 64H38.04c1.63 0 3.102-.971 3.743-2.468l16.069-37.49c.216-.508.329-1.054.329-1.605V4.073A4.073 4.073 0 0 0 54.109 0H36.143c-.805 0-1.591.239-2.26.685L1.812 22.088a4.07 4.07 0 0 0-1.811 3.387L0 59.927A4.073 4.073 0 0 0 4.073 64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M52 12H12v40h40z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.764 31.625q1.761 1.014 3.932 1.015 2.084 0 3.759-.93a6.9 6.9 0 0 0 2.646-2.538q.972-1.62.972-3.618v-1.188h-6.405v2.322h3.516a3.3 3.3 0 0 1-.61 1.534q-.595.821-1.61 1.285-1.005.465-2.247.465-1.339 0-2.42-.67a4.7 4.7 0 0 1-1.695-1.836q-.605-1.177-.605-2.646t.605-2.635a4.7 4.7 0 0 1 1.696-1.847q1.08-.67 2.42-.67.907 0 1.695.292.789.28 1.372.81.595.518.94 1.231h3.154a6.4 6.4 0 0 0-1.437-2.614 6.9 6.9 0 0 0-2.506-1.76Q25.456 17 23.696 17q-2.172 0-3.932 1.026a7.3 7.3 0 0 0-2.765 2.808q-1.005 1.782-1.005 3.986T17 28.816a7.4 7.4 0 0 0 2.765 2.808"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M36.183 31.625q1.77 1.014 3.942 1.015 2.182 0 3.942-1.016a7.4 7.4 0 0 0 2.776-2.808q1.005-1.792 1.005-3.996t-1.005-3.986a7.27 7.27 0 0 0-2.776-2.808C42.894 17.34 41.572 17 40.125 17q-2.17 0-3.942 1.026a7.4 7.4 0 0 0-2.776 2.808q-1.005 1.782-1.004 3.986t1.004 3.996a7.5 7.5 0 0 0 2.776 2.808m6.362-2.247q-1.07.67-2.409.67-1.34 0-2.42-.67a4.75 4.75 0 0 1-1.684-1.868q-.605-1.2-.605-2.69t.605-2.678q.615-1.2 1.685-1.869a4.44 4.44 0 0 1 2.42-.68q1.338 0 2.408.68 1.069.67 1.674 1.869.605 1.188.605 2.678c0 1.49-.202 1.89-.605 2.69a4.7 4.7 0 0 1-1.674 1.868",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.994 44h16v3h-16z"
  })));
};
export default SvgGoland;